export default "__VITE_ASSET__BMSFegl3__"